import React, {PropsWithChildren} from 'react';
import {Flex, Heading, useColorModeValue} from '@chakra-ui/react';

interface ContentHeaderProps {
  pageTitle?: string;
}

export const ContentHeader: React.FC<PropsWithChildren<ContentHeaderProps>> = ({
  pageTitle
}) => {
  return (
    <Flex as='header' p='32px 32px 0' w='100%'>
      <Flex
        borderBottom='1px'
        borderColor={useColorModeValue('gray.300', 'gray.700')}
        paddingBottom='24px'
        flex={1}
      >
        <Heading as='h1' size='md'>
          {pageTitle}
        </Heading>
      </Flex>
    </Flex>
  );
};
